module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_1.41783943.png";